import request from '@/utils/request';

// login
export function login(data) {
  return request({
    url: 'sysLogin',
    method: 'post',
    data: data
  });
}

// info
export function getInfo(token) {
  return request({
    url: 'getAdminInfo',
    method: 'post',
    data: {
      token: token
    }
  });
}
export function logout(token) {
  return request({
    url: 'sysExit',
    method: 'post',
    data: {
      token: token
    }
  });
}

// school
export function schoolList(data) {
  return request({
    url: 'searchSchool',
    method: 'post',
    data: data
  });
}
export function getStudentList(data) {
  return request({
    url: 'studentList',
    method: 'post',
    data: data
  });
}
export function getLoginQrcode() {
  return request({
    url: 'generateLoginQrCode',
    method: 'post'
  });
}
export function checkScanState(ck) {
  return request({
    url: 'queryLoginQrCode',
    method: 'post',
    data: {
      ck: ck
    }
  });
}

//修改密码
export function updatePassword(data) {
  return request({
    url: 'updatePassword',
    method: 'post',
    data: data
  });
}
// 新修改密码 信息等
export function updateUserinfo(data) {
  return request({
    url: 'updateUserinfo',
    method: 'post',
    data: data
  });
}
//信息提示
export function getInformationReminder(data) {
  return request({
    url: 'getInformationReminder',
    method: 'get',
    params: data
  });
}
//管理机构-重要通知-查询重要通知
export function getTaskDesignateList(data) {
  return request({
    url: 'getOthersTaskDesignateList',
    method: 'post',
    data: data
  });
}

/*************************    演示接口 start   ************************/

//不同帐号创建提醒信息
export function addDemoData(data) {
  return request({
    url: 'addDemoData',
    method: 'post',
    data: data
  });
}

//获取收到提醒信息
export function getDemoDataList(params) {
  return request({
    url: 'getDemoDataList',
    method: 'get',
    params: params
  });
}

//停止推送提醒信息
export function updateDemoData(params) {
  return request({
    url: 'updateDemoData',
    method: 'get',
    params: params
  });
}

//演示账号列表
export function getUsernameWithoutPassword(params) {
  return request({
    url: 'getUsernameWithoutPassword',
    method: 'get',
    params: params
  });
}

//演示账号登录
export function demoAccountLogin(params) {
  return request({
    url: 'demoAccountLogin',
    method: 'get',
    params: params
  });
}

/*************************    演示接口 end  ************************/